export default __webpack_public_path__ + "static/media/check-round.8a108fa4.svg";